import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  // 有锚点跳转锚点，没有到头部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.hash) {
        return {
          selector: to.hash
        }
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'safety-center',
      component: () => import('./components/about-our-safety-center.vue')
    },
    {
      path: '/safety-tips',
      name: 'safety-tips',
      component: () => import('./components/safety-tips.vue')
    },
    {
      path: '/community-guidelines',
      name: 'community-guidelines',
      component: () => import('./components/our-community-guidelines.vue')
    },
    {
      path: '/social-awareness',
      name: 'social-awareness',
      component: () => import('./components/online-social-awareness.vue')
    },
    {
      path: '/safety-tools',
      name: 'safety-tools',
      component: () => import('./components/our-safety-tools.vue')
    },
    {
      path: '/child-safety-policy',
      name: 'child-safety-policy',
      component: () => import('./components/child-safety-policy.vue')
    },
    {
      path: '/make-report',
      name: 'make-report',
      component: () => import('./components/make-a-report.vue')
    },
    {
      path: '/law-enforcement',
      name: 'law-enforcement',
      component: () => import('./components/for-law-enforcement.vue')
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: () => import('./components/faqs.vue')
    }
  ]
})
